class StickyAddToCart extends HTMLElement {
  constructor() {
    super();
    this.buttonObserver = null;
    this.footerObserver = null;
    this.buttonHidden = false;
    this.footerVisible = false;
  }

  connectedCallback() {
    // Move element to body to escape section stacking context.
    // appendChild re-inserts this element, which fires connectedCallback again, so
    // bail out until it is already where we want it -- otherwise this recurses until
    // the call stack overflows and init() runs once per unwound frame.
    if (this.parentElement !== document.body) {
      document.body.appendChild(this);
      return;
    }

    // Guard on the observers rather than a flag, so ordering of the move's
    // disconnect/connect reactions cannot leave this half-wired.
    if (this.buttonObserver) return;

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => this.init());
    } else {
      this.init();
    }
  }

  init() {
    const originalButton = document.querySelector(
      '.pdp-atc button[type="submit"]',
    );
    const footer = document.querySelector("#shopify-section-group-footer");

    if (!originalButton) {
      return;
    }

    // Watch original ATC button
    this.buttonObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          this.buttonHidden = !entry.isIntersecting;
          this.updateVisibility();
        });
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 0,
      },
    );
    this.buttonObserver.observe(originalButton);

    // Watch footer — hide sticky bar when footer is visible
    if (footer) {
      this.footerObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            this.footerVisible = entry.isIntersecting;
            this.updateVisibility();
          });
        },
        {
          root: null,
          rootMargin: "0px",
          threshold: 0,
        },
      );
      this.footerObserver.observe(footer);
    }
  }

  updateVisibility() {
    this.classList.toggle("visible", this.buttonHidden && !this.footerVisible);
  }

  disconnectedCallback() {
    // Moving the element fires this too; only tear down on a real detach.
    if (this.isConnected) return;

    if (this.buttonObserver) {
      this.buttonObserver.disconnect();
      this.buttonObserver = null;
    }
    if (this.footerObserver) {
      this.footerObserver.disconnect();
      this.footerObserver = null;
    }
  }
}

customElements.define("sticky-add-to-cart", StickyAddToCart);
